// Export for a consistent use of momentjs extended with moment-range

import Moment from 'moment'
import { extendMoment } from 'moment-range'

export default extendMoment(Moment)



// WEBPACK FOOTER //
// ./src/lib/moment.js